var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @file [Please Input File Description]
 * @author (zhaojun10)
 */

import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { classPrefix } from '../../common/util';
/* global getComputedStyle window */

var TabNav = function (_Component) {
    _inherits(TabNav, _Component);

    function TabNav() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, TabNav);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = TabNav.__proto__ || Object.getPrototypeOf(TabNav)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
            isShowButton: false,
            ulTranslate: 0,
            rightDisabled: false,
            leftDisabled: false
        }, _this.getIsShowButtonValue = function () {
            var ulWidth = parseFloat(getComputedStyle(_this.ul)['width']);
            var windowWidth = parseFloat(getComputedStyle(_this.window)['width']);
            var MAX_TRANSLATE = ulWidth - windowWidth;
            if (ulWidth > windowWidth) {
                _this.setState({
                    isShowButton: true,
                    leftDisabled: _this.state.ulTranslate === 0,
                    rightDisabled: _this.state.ulTranslate === -MAX_TRANSLATE
                });
            } else {
                _this.setState({
                    isShowButton: false,
                    ulTranslate: 0,
                    leftDisabled: true,
                    rightDisabled: false
                });
            }
        }, _this.leftButtonClick = function () {
            var ulWidth = parseFloat(getComputedStyle(_this.ul).width);
            var windowWidth = parseFloat(getComputedStyle(_this.window).width);
            var MIN_TRANSLATE = 0;
            var MAX_TRANSLATE = ulWidth - windowWidth;
            var ulTranslate = _this.state.ulTranslate;
            var leftDisabled = false;
            // 点击后移动距离判断和是否禁止点击
            if (ulTranslate + windowWidth <= MIN_TRANSLATE) {
                ulTranslate = ulTranslate + windowWidth;
            } else {
                ulTranslate = MIN_TRANSLATE;
                leftDisabled = true;
            }
            _this.setState({
                ulTranslate: ulTranslate,
                leftDisabled: leftDisabled,
                rightDisabled: ulTranslate === -MAX_TRANSLATE
            });
        }, _this.rightButtonClick = function () {
            var ulWidth = parseFloat(getComputedStyle(_this.ul).width);
            var windowWidth = parseFloat(getComputedStyle(_this.window).width);
            var ulTranslate = _this.state.ulTranslate;
            var MAX_TRANSLATE = ulWidth - windowWidth;
            var MIN_TRANSLATE = 0;
            var rightDisabled = false;
            // 点击后移动距离判断和是否禁止点击
            if (-(ulTranslate - windowWidth) <= MAX_TRANSLATE) {
                ulTranslate = ulTranslate - windowWidth;
            } else {
                ulTranslate = -MAX_TRANSLATE;
                rightDisabled = true;
            }
            _this.setState({
                ulTranslate: ulTranslate,
                rightDisabled: rightDisabled,
                leftDisabled: ulTranslate === MIN_TRANSLATE
            });
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(TabNav, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            if (this.props.responsive) {
                this.getIsShowButtonValue();
                window.addEventListener('resize', this.getIsShowButtonValue);
            }
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            if (this.props.responsive) {
                window.removeEventListener('resize', this.getIsShowButtonValue);
            }
        }
    }, {
        key: 'getTabs',
        value: function getTabs() {
            var _this2 = this;

            var _props = this.props,
                panels = _props.panels,
                classPrefix = _props.classPrefix,
                activeIndex = _props.activeIndex,
                backgroundColor = _props.backgroundColor,
                tabType = _props.tabType,
                skin = _props.skin;

            return React.Children.map(panels, function (child) {
                if (!child) {
                    return;
                }

                var order = parseInt(child.props.order, 10);
                var classes = void 0;
                if (order === 0) {
                    var _classnames;

                    classes = classnames((_classnames = {}, _defineProperty(_classnames, classPrefix + '-tab-tab', true), _defineProperty(_classnames, classPrefix + '-tab-tab-purple', skin === 'purple'), _defineProperty(_classnames, classPrefix + '-tab-active', activeIndex === order), _defineProperty(_classnames, classPrefix + '-tab-active-purple', activeIndex === order && skin === 'purple'), _defineProperty(_classnames, classPrefix + '-tab-disabled', child.props.disabled), _classnames));
                } else {
                    var _classnames2;

                    classes = classnames((_classnames2 = {}, _defineProperty(_classnames2, classPrefix + '-tab-tab', true), _defineProperty(_classnames2, classPrefix + '-tab-tab-purple', skin === 'purple'), _defineProperty(_classnames2, classPrefix + '-tab-active', activeIndex === order), _defineProperty(_classnames2, classPrefix + '-tab-active-purple', activeIndex === order && skin === 'purple'), _defineProperty(_classnames2, classPrefix + '-tab-disabled', child.props.disabled), _classnames2));
                }

                var events = {};
                if (!child.props.disabled) {
                    events = {
                        onClick: _this2.props.onTabClick.bind(_this2, order, child.props.onHandleClick)
                    };
                }

                var ref = {};
                if (activeIndex === order) {
                    ref.ref = 'activeTab';
                }
                var style = tabType !== 'underline' ? {
                    backgroundColor: backgroundColor,
                    borderBottomColor: backgroundColor
                } : null;
                return React.createElement(
                    'li',
                    _extends({
                        role: 'tab',
                        id: 'tab' + order,
                        'data-disabled': child.props.disabled ? 'true' : 'false',
                        'data-selected': activeIndex === order ? 'true' : 'false'
                    }, events, {
                        className: classes,
                        key: order
                    }, ref, {
                        style: activeIndex === order ? style : null
                    }),
                    child.props.tab
                );
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var _classnames5,
                _this3 = this;

            var _props2 = this.props,
                classPrefix = _props2.classPrefix,
                backgroundColor = _props2.backgroundColor,
                responsive = _props2.responsive;


            var rootClasses = classnames(_defineProperty({}, classPrefix + '-tab-bar', true));

            var classes = classnames(_defineProperty({}, classPrefix + '-tab-nav', true));
            var style = {
                backgroundImage: 'linear-gradient(-90deg, rgba(255,255,255,0.00) 0%, ' + backgroundColor + ' 100%)'
            };

            var windowCls = classnames((_classnames5 = {}, _defineProperty(_classnames5, classPrefix + '-tab-window', true), _defineProperty(_classnames5, 'responsive', responsive), _defineProperty(_classnames5, 'has-button', this.state.isShowButton), _classnames5));

            var ulStyle = { transform: 'translate(' + this.state.ulTranslate + 'px)' };

            var rightButtonCls = classnames({
                'right-button': true,
                disabled: this.state.rightDisabled
            });

            var leftButtonCls = classnames({
                'left-button': true,
                disabled: this.state.leftDisabled
            });

            return React.createElement(
                'div',
                { className: rootClasses, role: 'tablist' },
                React.createElement(
                    'div',
                    {
                        className: windowCls,
                        ref: function ref(el) {
                            _this3.window = el;
                        }
                    },
                    React.createElement(
                        'ul',
                        {
                            className: classes,
                            ref: function ref(el) {
                                _this3.ul = el;
                            },
                            style: ulStyle
                        },
                        this.getTabs()
                    )
                ),
                this.state.isShowButton && React.createElement(
                    Fragment,
                    null,
                    React.createElement('div', { className: leftButtonCls, onClick: this.leftButtonClick }),
                    React.createElement('div', { className: 'left-mask', style: style }),
                    React.createElement('div', { className: rightButtonCls, onClick: this.rightButtonClick }),
                    React.createElement('div', { className: 'right-mask', style: style })
                )
            );
        }
    }]);

    return TabNav;
}(Component);

TabNav.propTypes = {
    classPrefix: PropTypes.string,
    panels: PropTypes.node,
    activeIndex: PropTypes.number,
    onTabClick: PropTypes.func,
    backgroundColor: PropTypes.string,
    tabType: PropTypes.string,
    skin: PropTypes.string,
    responsive: PropTypes.bool
};
TabNav.defaultProps = {
    classPrefix: classPrefix
};
export default TabNav;